<template>
  <div>
    <b-navbar type="dark" style="background-color: #222f3e">
      <b-navbar-nav align="center">
        <!-- Navbar dropdowns -->
        <b-nav-item-dropdown v-for="(aCategory,i) in categories"
                             :text="aCategory.title"
                             right
                             style="color:green"
                             :key="`cat-${i}`"
        >
          <b-dropdown-item href="#">Sweet 16</b-dropdown-item>
        </b-nav-item-dropdown>

      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/assets/_config.json";
import moment from "moment";

export default {
  name: "Home_Site",
  components: {},
  computed: {
    ...mapGetters({
      allMemories: "admin/memories"
    })
  },
  created() {
    this.getMemories();
  },
  methods: {
    getMemories(){
      this.$store.dispatch("admin/getMemories").then((res)=>{
        console.log(res);
      });
    },
    formatDate(date) {
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    }
  },
  mounted() {},
  data() {
    return {
      id: "success-modal",
      config,
      loading: false,
      categories:[
        {
          title:"Gift Cards",
          _created_at:123
        },
        {
          title:"Find A Gift",
          _created_at:123
        },
        {
          title:"Plushies",
          _created_at:123
        },
        {
          title:"Buy Again",
          _created_at:123
        },
        {
          title:"Household",
          _created_at:123
        },
        {
          title:"HandMade",
          _created_at:123
        },
        {
          title:"Beauty & Personal Care",
          _created_at:123
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.coming-soon {
  padding-top: 100px;
  background: #FE828C;
}
</style>
